import { render } from "./news-modal.vue?vue&type=template&id=1aa26009&scoped=true"
import script from "./news-modal.vue?vue&type=script&lang=js"
export * from "./news-modal.vue?vue&type=script&lang=js"

import "./news-modal.vue?vue&type=style&index=0&id=1aa26009&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1aa26009"]])

export default __exports__